export default class ErrorHandler {
    static show(errorBox) {
        const error = document.querySelector(errorBox);
        error.style.display = "block";
    }
    static hide(errorBox) {
        const error = document.querySelector(errorBox);
        error.style.display = "none";
    }
    static hideAll() {
        const errors = document.querySelectorAll(".form__error");
        errors.forEach((error) => {
            error.style.display = "none";
        });
    }
}
